<template>
  <input hidden :name="name + (multiple == 1 ? '[]' : '')" type="text" v-model="modelo">
  <div class="dropzone" ref="dropzoneWrapper">
          <!-- <div ref="dropzoneContainer" class="dz-preview dz-file-preview h-48 bg-red-500">
            <div class="dz-details rounded-2xl bg-verde-50 p-2 flex items-center justify-between">
                  <img class="rounded-lg" data-dz-thumbnail />
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div class="dz-size" data-dz-size></div>
                </div>
              <div class="relative mt-5 h-[6px] w-full rounded-lg bg-[#E2E5EF]"><span class="absolute left-0 right-0 h-full w-[75%] rounded-lg bg-[#6A64F1]" data-dz-uploadprogress></span></div>
              <div class="dz-success-mark"><span>✔</span></div>
              <div class="dz-error-mark"><span>✘</span></div>
              <div class="p-7 text-black"><span data-dz-errormessage></span></div>
          </div> -->
      </div>

      <div ref="removeButton" class="hidden">
        <svg class="size-5 {{ isset($invalid) ? 'text-red-500' : 'text-verde-500' }}"><use xlink:href="/storage/img/new-icons.svg?file#carbon-trash-can" /></svg>
      </div>

      <div ref="inputHtml" class="hidden">
        <div :for="name" class="block w-full">
          <div class="relative mt-3 w-full bg-neutral-100 rounded-lg shadow-inner hover:bg-neutral-200">
              <div :for="name" class="z-20 flex flex-col-reverse items-center justify-center w-full h-full cursor-pointer p-12">
                  <p class="z-10 text-xs font-light text-center text-neutral-500 mt-2">Arraste os seus ficheiros para aqui</p>
                  <svg class="size-7 sm:size-8 text-verde-500"><use xlink:href="/storage/img/new-icons.svg?file#carbon-cloud-upload" /></svg>
              </div>
          </div>
      </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import _ from 'lodash';
import { useFormStore } from '@/stores/form.js'
const formStore = useFormStore()

import Dropzone from 'dropzone';
// import "dropzone/dist/basic.css";
import CircleProgress from 'js-circle-progress'

const props = defineProps({
  name: String,
  multiple: Number
})

const selectedFiles = ref([])
const selectedFile = ref()

const dropzoneWrapper = ref(null)
const fileInput = ref(null)
const dropzoneContainer = ref(null)
const removeButton = ref(null)
const inputHtml = ref(null)

const fileType = (fileName) => {
    var fileType = /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName) : undefined;
    return fileType[0];
}

const modelo = computed(() => {
  return props.multiple == 1 ? selectedFiles.value : selectedFile.value
})

onMounted(() => {
  const dropzone = new Dropzone(dropzoneWrapper.value, {
    url: '/file-upload', // Laravel upload route
    autoProcessQueue: true, //false, // Disable automatic uploads
    paramName: 'file', // File parameter name
    maxFilesize: 5, // Max file size in MB
    maxFiles: props.multiple == 1 ? 5 : 1, // Max number of files
    acceptedFiles: props.multiple == 1 ? 'image/*' : 'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,', // Accepted file types
    addRemoveLinks: true, // Show remove button
    thumbnailWidth: 40,
    thumbnailHeight: 40,
    hiddenInputContainer: dropzoneWrapper.value,

    dictRemoveFile: removeButton.value.innerHTML,

    dictCancelUpload: removeButton.value.innerHTML,

    dictDefaultMessage: inputHtml.value.innerHTML,
    dictFallbackMessage: "O seu navegador não suporta o upload de ficheiros por arrastar e largar.",
    dictFileTooBig: 'O ficheiro é demasiado grande ({{filesize}}MB). Tamanho máximo: {{maxFilesize}}MB.',
    dictInvalidFileType: "Não pode carregar ficheiros deste tipo.",
    dictResponseError: 'O servidor respondeu com o código {{statusCode}}.',
    dictUploadCanceled: 'Upload cancelado.',
    dictCancelUploadConfirmation: 'Tem a certeza de que deseja cancelar este upload?',
    dictMaxFilesExceeded: 'Atingiu o limite de uploads para este campo.', // Default: You can not upload any more files.

    // createImageThumbnails: false,
    // previewTemplate: dropzoneContainer.value.innerHTML,
    // addedfile: function(file) {
    //   selectedFile.value = file;
    // },
    // sending: (file, xhr, formData) => {
    //   const token = document.head.querySelector('meta[name="csrf-token"]').content;
    //   formData.append('_token', token);
    // },
    // uploadprogress: (file, progress, bytesSent) => {
    //   console.log(file, progress, bytesSent);
    // },
    // success: (file, response) => {
    //   console.log('File uploaded successfully:', response);
    // }
    });

  dropzone.on("addedfile", (file) => {
    var extension = fileType(file.name);
    if(extension != 'pdf' && extension != 'doc' && extension != 'docx') extension = 'default'
    file.previewElement.classList.add('type-' + extension);
    
  });
  
  dropzone.on("sending", (file, xhr, formData) => {
    const token = document.head.querySelector('meta[name="csrf-token"]').content;
    formData.append('_token', token);
    formData.append('type', props.name);
    formData.append('registoId', formStore.registoId);
  });

  dropzone.on("uploadprogress", (file, progress, bytesSent) => {
    console.log(file, progress, bytesSent);
  });

  dropzone.on("success", (file, response) => {
    console.log(response)
    const fieldIndex = _.findIndex(formStore.step.fields, function(field) { return field.slug == props.name; });
      console.log('fieldIndex', fieldIndex)
    if(props.multiple == 1) {
      selectedFiles.value.push(response);
      formStore.step.fields[fieldIndex].valor.push(response)
    } else {
      selectedFile.value = response;

      
      formStore.step.fields[fieldIndex].valor = response
    }
  });

  // dropzone.on("error", (file, responseText) => {
  //   console.log('Error:', file);
  //   var msgEl = file.previewElement.querySelector('.dz-error-message');
  //   console.log('Error2:', msgEl);
  //     msgEl.innerHTML(responseText.message);
  //     msgEl.show();
  // });



const fileSelected = (event) => {
  // Triggered when a file is selected via the file input
  const file = event.target.files[0];
  dropzone.addFile(file);
}
const uploadFile = () => {
  // Manually trigger file upload
  dropzone.processQueue();
}
const removeFile = () => {
  // Remove currently selected file
  dropzone.removeAllFiles();
}
})
</script>

<style>
.dropzone,
.dropzone * {
    box-sizing: border-box
}

.dropzone {
    @apply relative w-full;

    
}

.dropzone .dz-button {
    @apply block w-full;

    
}

.dropzone .dz-preview {
    @apply bg-verde-50 w-full p-4 rounded-2xl mt-1;
    position: relative;
    /* display: inline-block;
    width: 120px;
    margin: .5em */

    .dz-image {
      @apply absolute top-4 left-4 size-10 rounded-lg overflow-hidden;
    }
    .dz-image:after {
        content: '';
        position: absolute;
        inset: 0;
        background-size: cover;
        /* background-size: 75%; */
        background-position: left center;
        background-repeat: no-repeat;
    }

    .type-pdf .dz-image:after {
      background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDU2IDU2Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjNTdhYzM2OwogICAgICB9CgogICAgICAuY2xzLTEsIC5jbHMtMiwgLmNscy0zIHsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMmM1NDIwOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM2LjksMEg3LjlDNy4yLDAsNi40LjYsNi40LDEuOXY1My4xYzAsLjQuNiwxLDEuNSwxaDQwLjFjLjcsMCwxLjUtLjYsMS41LTFWMTNjMC0uNywwLS45LS4zLTEuMUwzNy43LjNDMzcuNCwwLDM3LjIsMCwzNi45LDBoMFoiLz4KICA8cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0zNy40LDB2MTEuOWgxMS45TDM3LjQsMFoiLz4KICA8cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNy4zLDM0LjNoLTEuNnYtMTAuMmgyLjljLjQsMCwuOS4xLDEuMi4zLjQuMS43LjQsMS4xLjYuNC4zLjYuNi43LDEsLjMuNC4zLjkuMywxLjIsMCwuNS0uMSwxLS4zLDEuNC0uMS40LS40LjctLjcsMS0uMy4zLS42LjUtMS4xLjYtLjQuMS0uOS4zLTEuNS4zaC0xLjN2My44aC4zWk0xNy4zLDI1LjR2NGgxLjVjLjMsMCwuNCwwLC42LS4xcy40LS4xLjUtLjRjLjEtLjEuMy0uNC40LS42cy4xLS42LjEtMSwwLS40LS4xLS42YzAtLjMtLjEtLjQtLjMtLjYtLjEtLjMtLjQtLjQtLjYtLjUtLjMtLjEtLjYtLjMtMS0uM2gtMS4xWiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTMyLjIsMjguOWMwLC45LDAsMS41LS4zLDIuMS0uMS42LS40LDEuMS0uNiwxLjUtLjMuNC0uNi43LS45LDEtLjQuMy0uNi40LTEsLjVzLS42LDAtLjkuM2gtNC41di0xMC4yaDNjLjksMCwxLjYuMSwyLjIuNHMxLjEuNiwxLjYsMS4xYy40LjUuNywxLDEsMS41LjMuNy40LDEuMy40LDEuOGgwWk0yNy4zLDMzYzEuMSwwLDEuOS0uNCwyLjQtMS4xLjUtLjcuNy0xLjguNy0zLjFzMC0uOS0uMS0xLjItLjMtLjctLjYtMS4xYy0uMy0uNC0uNi0uNi0xLjEtLjctLjUtLjMtMS4xLS4zLTEuOS0uM2gtMXY3LjVoMS42WiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTM2LjIsMjUuNHYzLjFoNC4zdjEuMWgtNC4zdjQuNWgtMS42di0xMC4xaDYuM3YxLjNoLTQuNmMwLC4xLS4xLjEtLjEuMVoiLz4KPC9zdmc+);
    }
    .type-docx .dz-image:after,
    .type-doc .dz-image:after {
        background-image: url(data:image/svg+xml;base64,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);
    }
    .dz-details {
        @apply h-10 flex items-center justify-between px-14 overflow-hidden text-xs;
    
        .dz-size {
          @apply hidden;
      }
    }

    .dz-progress {
      @apply relative mt-2 h-[6px] w-full rounded-lg bg-neutral-200;

      .dz-upload {
        @apply absolute left-0 right-0 h-full rounded-lg bg-verde-500;
      }
    }

    .dz-success-mark,
    .dz-error-mark {
      @apply hidden;
    }

    .dz-remove {
      @apply absolute top-0 right-0 m-4 size-8 rounded-full text-verde-500 hover:text-verde-800 flex items-center justify-center;
    }

    &.dz-error {
      @apply bg-red-50;

      .dz-progress {
        .dz-upload {
          @apply bg-red-500;
        }
      }

      .dz-details {
        @apply pl-0;
      }

      .dz-image,
      .dz-image:after {
        display: none
      }

      .dz-remove {
        @apply text-red-500 hover:text-red-800;
      }
      
      .dz-error-message {
        @apply text-xs mt-2 text-red-500;
      }
    }
}
</style>
